export const QUERY_KEYS = {
  ORDER_SUMMARY: 'orderSummary',
  SHIPPING_RATES: 'shippingRates',
  PAYMENT_SOURCES: 'paymentSources',
  PAYMENT_OPTIONS: 'paymentOptions',
  OFFERS: 'offers',
  APPLICATION_FLOWS: 'applicationFlows',
  PICKUP_OPTIONS: 'pickupOptions',
  GET_PRODUCT_ADD_ONS: 'getProductAddOns',
  PICKUP_OPTIONS_SLUG: 'pickupOptionsBySlug',
};

export const MUTATION_KEYS = {
  ORDER_COMPLETE: 'orderComplete',
  OFFER_SELECT: 'offerSelect',
  GET_ADDRESS_SUGGESTIONS: 'getAddressSuggestions',
  GET_SUGGESTION_DETAILS: 'getSuggestionDetails',
  VALIDATE_ADDRESS: 'validateAddress',
  UPDATE_ORDER_ADDRESS_INFORMATION: 'updateOrderAddressInformation',
  SELECT_SHIPPING_RATE: 'selectShippingRate',
  SELECT_PAYMENT_OPTION: 'selectPaymentOption',
  DELETE_SAVED_CARD: 'deleteSavedCard',
  FINANCING_DISCLOSURES: 'financingDisclosures',
  SUBMIT_APPLICATION_FLOW: 'submitApplicationFlow',
  RESERVE_PICKUP_LOCATION: 'reservePickupLocation',
  UPDATE_PICKUP_PERSON: 'updatePickupPerson',
  RECAPTCHA_FALLBACK: 'recaptchaFallback',
  UPDATE_LINE_ITEM_QUANTITY: 'updateLineItemQuantity',
  REDEEM_REDEMPTION_CODE: 'redeemRedemptionCode',
};
